<template>
  <b-modal
    @hidden="resetData"
    ref="settings-stations-modal"
    :title="'Gerer les stations de la boucle ' + currentLoop.description"
    hide-footer
  >
    <div class="container-fluid my-3">
      <div class="row justify-content-center mt-2">
        <p class="col-12">Vous pouvez ajouter ou supprimer une station et changer l'ordre des stations</p>
        <div class="col-12">
          <b-button
            class="m-1 add-workstation-btn"
            :class="formVisible ? null : 'collapsed'"
            :aria-expanded="formVisible ? 'true' : 'false'"
            aria-controls="add-station"
            @click="toggleForm"
            >
              <i class="fa fa-plus"></i>
              <span class="ml-2">Ajouter une station</span>
          </b-button>
          <b-button
            class="m-1 delete-workstation-btn"
            variant="danger"
            @click="toggleDeleteStation"
            >
              <i class="fa fa-trash"></i>
              <span class="ml-2">Supprimer une station</span>
          </b-button>
          <b-collapse
            v-model="formVisible"
            id="add-station"
          >
             <b-form-row
              class="justify-content-center"
            >
              <b-col
                class="mt-2"
                cols="12"
              >
                <label for="station-name">Nom de la station</label>
                <b-form-input
                  id="station-name"
                  type="text"
                  required
                  aria-label="Nom de la station"
                  v-model="newStation.name"
                />
              </b-col>
              <b-col
                class="mt-2"
                md="6"
              >
                <label for="station-max-doc">Nombre max. de documents</label>
                <b-form-input
                  id="station-max-doc"
                  type="number"
                  min="0"
                  required
                  oninput="validity.valid||(value='');"
                  aria-label="Nombre maximum de documents"
                  v-model="newStation.max_documents"
                />
              </b-col>
              <b-col
                class="mt-2"
                md="6"
              >
                <label for="station-max-ld">Lead Time maximum</label>
                <b-form-input
                  id="station-max-ld"
                  type="number"
                  min="0"
                  required
                  oninput="validity.valid||(value='');"
                  aria-label="Lead Time maximum"
                  v-model="newStation.max_lead_time"
                />
              </b-col>
              <div class="mt-4">
                <b-button
                  variant="primary"
                  @click="addWorkstation"
                  >
                  Ajouter
                </b-button>
              </div>
            </b-form-row>
          </b-collapse>
          <b-collapse
            v-model="deletingStation"
          >
            <b-alert show variant="danger mt-2">
              Attention la suppression d'une station est irréversible. <br>
              Si des scans sont associés à cette station, ils seront également supprimés.
            </b-alert>
          </b-collapse>
        </div>
        <div class="col-12 text-center">
          <div class="stations-list">
            <draggable
              v-model="stationsList"
              :disabled="deletingStation"
              group="stations"
              ghost-class="ghost"
             @start="drag=true"
             @end="drag=false"
            >
              <div
                v-for="(station, index) in stationsList"
                :key="index"
                class="station"
                :class="{'draggable': !deletingStation}"
                v-if="station.position !== 0"
              >
                <div v-if="!deletingStation" class="station-position">
                  <small>Position actuelle</small>
                  <div>{{station.position}}</div>
                </div>

                <div
                  v-else
                  class="delete-station clickable"
                  @click="deleteWorkstation(station)"
                >
                  <small>Supprimer</small>
                  <div><i class="fa fa-trash"></i></div>
                </div>

                <div class="station-name">
                  <small>Nom de la station</small>
                  <div>{{station.name}}</div>
                </div>
              </div>
            </draggable>
          </div>
          <div v-if="!deletingStation" class="mt-4">
            <b-button
              variant="outline-danger"
              @click="hideModal"
              class="mr-5"
              >Annuler</b-button
            >
            <b-button
              variant="primary"
              @click="updateWorkstations"
              >
              Valider
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import draggable from 'vuedraggable'
import server from '../api/server.vue'
import _ from 'lodash'

export default {
  name: 'settings-stations-modal',
  components: {
      draggable,
  },
  props: [],
  data() {
    return {
      currentLoop: {},
      stationsList: [],
      newStation: {},
      formVisible: false,
      deletingStation: false,
    }
  },
  methods: {
    toggleDeleteStation () {
      this.deletingStation = !this.deletingStation
      if (this.deletingStation) {
        this.formVisible = false
      }
    },
    toggleForm () {
      this.formVisible = !this.formVisible
      if (this.formVisible) {
        this.deletingStation = false
      }
    },
    updateWorkstationPosition (station, newPosition) {
      const params = {
                      workstation_to_update: station.name,
                      name: station.name,
                      position: newPosition,
                     }
      return server.updateWorkstation(this.currentLoop.name, params).then((res) => {
        this.$toasted.success(` La position de la station ${station.name} a bien été mise à jour`)
      }).catch((err) => {
        this.$toasted.error('Erreur lors de la mise à jour de la station ' + station.name)
      })
    },
    checkPositionAllWorkstations () {
      const promises = []
      this.stationsList.forEach((station, index) => {
        if (station.position !== index) {
          promises.push(this.updateWorkstationPosition(station, index))
        }
      })
      Promise.all(promises).then(() => {
        this.$emit('settings-stations-modal-closed')
        this.hideModal()
      })
    },
    addWorkstation () {
      this.formVisible = false
      const lastPosition = this.stationsList.length
      this.newStation.position = lastPosition
      this.stationsList.push(this.newStation)
      this.newStation = {}
    },
    deleteWorkstation (station) {

      if (!station.uniqid) {
        return this.stationsList = this.stationsList.filter(item =>  item.name !== station.name)
      }
      this.$bvModal.msgBoxConfirm(`Etes-vous sur de vouloir supprimer la station ${station.name} ainsi que tous les scan associés?`).then((value) => {
        if (value) {

          const loopName = station.loop_obj.name
          server.deleteWorkstationItem(loopName, station.name).then((result) => {
            this.stationsList = this.stationsList.filter(item =>  item.name !== station.name)
            this.$toasted.success(`Station ${station.name} supprimée avec succes`)
            this.checkPositionAllWorkstations()
          }).catch((err) => {
            this.$toasted.error('Erreur lors de la suppression de la station')
          })
        }
      })
    },
    createWorkstation () {
      const promises = []
      this.stationsList.forEach((station) => {
        if (station.uniqid) {
          return Promise.resolve()
        }
        server.createWorkstation(this.currentLoop.name, station).then((result) => {
          this.$toasted.success(`Station ${result.name} créée avec succes`)
        }).catch((err) => {
          this.$toasted.error('Erreur lors de la création de la station')
        })

      })
      return Promise.all(promises)
    },
    updateWorkstations () {
      this.createWorkstation().then(() => {
        this.checkPositionAllWorkstations()
      })
    },
    getAllWorkstationsFromLoop () {
      return server.getWorkstations(this.currentLoop.name).then((result) => {
        this.stationsList = result.data
      }).catch((err) => {
        this.$toasted.error('Erreur lors de la récupération des informations de la boucle')
      })
    },
    resetData () {
      this.currentLoop = {}
      this.stationsList = []
      this.newStation = {}
      this.formVisible = false
      this.deletingStation = false
    },
    hideModal () {
      this.resetData()
      this.$refs['settings-stations-modal'].hide()
    },
    showModal (loop) {
      this.currentLoop = loop
      this.getAllWorkstationsFromLoop().then(() => {
        this.$refs['settings-stations-modal'].show()
      })
    },
  },
}
</script>

<style lang="scss">
  .add-workstation-btn {
    background-color: var(--a-dark-blue);

    &:hover {
      background-color: #236391;
    }
  }

  .stations-list {
    .station {
      display: flex;
      margin: 1rem 0;
      color: #ffffff;
      border-radius: 3px;
      width: 100%;
    }

    .station.draggable {
      cursor: grab;
    }

    .station .station-position {
      padding: 0.5rem;
      background-color: var(--a-dark-blue);
      width: 35%;
    }

    .station .station-name {
      padding: 0.5rem;
      background-color: var(--a-light-blue);
      text-align: center;
      flex-grow: 1;
    }

    .station:hover {
      box-shadow: 0px 0px 8px 4px #d0d0d0;
    }

    .ghost {
      opacity: 0.5;
      background: #c8ebfb;
    }

    .delete-station {
      padding: 0.5rem;
      background-color: var(--a-light-red);
      width: 35%;
    }

    .delete-station .fa-trash {
      font-size: 1.5rem
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/SettingsStationsModal.vue